var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Dialog",
    _vm._g(
      _vm._b(
        {
          attrs: {
            title: _vm.round ? _vm.locale.youGot : _vm.locale.noPrize,
            hasDecor: false,
          },
        },
        "Dialog",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    ),
    [
      _vm.round
        ? _c("div", { staticClass: "award-box" }, [
            _c("img", {
              staticClass: "award",
              attrs: { src: require("images/kv/award_4.png") },
            }),
            _c("span", { staticClass: "award-name" }, [
              _vm._v("amazon card $" + _vm._s(_vm.round)),
            ]),
          ])
        : _c("div", { staticStyle: { "margin-bottom": "50px" } }, [
            _vm._v(_vm._s(_vm.locale.sorry)),
          ]),
      _c(
        "button",
        {
          staticClass: "dialog-btn",
          attrs: { "data-type": "button" },
          on: { click: _vm.close },
        },
        [_c("span", [_vm._v(_vm._s(_vm.locale.confirm))])]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }